/**
 * Savings Page Wrapper for PDF Generation
 * 
 * Wraps the SavingsPage component with the dp-page class for print styling consistency
 */

import { SavingsPage } from '@system-rec/decision-ui';
import type { SavingsPageProps } from '@system-rec/decision-ui';

export function SavingsPageWrapper(props: SavingsPageProps) {
  return (
    <div className="dp-page savings-page-wrapper">
      <SavingsPage {...props} />
    </div>
  );
}
